import update from 'immutability-helper';
import { AutoReportConfigData } from 'src/models';
import { ActionType, defaultAction } from 'src/redux/types';
import { ACTION_TYPES } from './types';

export type AutoReportState = {
  data?: AutoReportConfigData;
  isLoading: boolean;
};

const initialState: AutoReportState = {
  isLoading: false,
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;

  switch (type) {
    case ACTION_TYPES.AUTO_REPORT_LOAD_CONFIG:
      return update(state, {
        isLoading: {
          $set: true,
        },
      });
    case ACTION_TYPES.AUTO_REPORT_LOAD_CONFIG_SUCCESS:
      return update(state, {
        data: {
          $set: payload.data,
        },
        isLoading: {
          $set: false,
        },
      });
    case ACTION_TYPES.AUTO_REPORT_LOAD_CONFIG_FAILED:
      return update(state, {
        isLoading: {
          $set: false,
        },
      });
    default:
      return state;
  }
};
